import React, { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import InputGroup from 'react-bootstrap/InputGroup';
// import IconPicker from '../IconPicker';
import { settingsFunctions } from '../../../../functions/settings';
import 'react-phone-number-input/style.css';
import PhoneInput, { formatPhoneNumberIntl } from 'react-phone-number-input';
import FloatingLabelInput from '../../../Custom/FloatingLabelInput';
import ButtonPreview from '../../../ButtonPreview';
import { useAuth } from '../../../../utils/Auth';
import './ButtonEditor.css';

function ButtonEditor(props) {
    const { setShowForm, buttons, setButtons, buttonToEdit, uid, accountType, setButtonToEdit, profile_theme } = props;
    const { updateVcardObject, buttonsActiveState, buttonRefArr, getButtonLink } = settingsFunctions;
    const  { getUpdatedUserVcard } = useAuth();
    
    const [ buttonActive, setButtonActive ] = useState(buttonToEdit.active);
    const [ buttonHasChanges, setButtonHasChanges ] = useState(false);
    const [ deleteConfirm, setDeleteConfirm ] = useState(false);
    const [ icon, setIcon ] = useState(buttonToEdit.icon);
    const [ index ] = useState(buttons.findIndex(btn => btn.data === buttonToEdit.data));
    const [ showSpinner, setShowSpinner] = useState(false);
    
    const [ button, setButton ] = useState(buttonToEdit?.data ? buttonToEdit.data : "");
    const [ label, setLabel ] = useState(buttonToEdit?.label ? buttonToEdit.label : "");

    const [ header ] = useState(
        <Card.Header className='button-editor-header'>
            <div className='button-editor-back-btn' onClick={e => {e.preventDefault(); setShowForm("")}}>
                <i className='fas fa-arrow-left'></i>
                Back
            </div>
            Edit Button
            <div className='button-editor-reset-btn' onClick={e => {e.preventDefault(); resetForm()}}>
                Reset
            </div>
        </Card.Header>
    );

    const handleTrash = async () => {
        const newArr = buttons.filter(btn => btn.data !== buttonToEdit.data);
        const update = { buttons: accountType === 'basic' ? buttonsActiveState(newArr, buttons) : newArr };
        
        setButtons(update.buttons);
        setShowSpinner(true);

        await updateVcardObject(update, uid).then(async () => {
            await getUpdatedUserVcard().then(() => {
                setShowSpinner(false);
                setShowForm('');
                setButtonHasChanges(false);
                setButtonToEdit('');
            });
        });
    };

    useEffect(() => {
        const confirmBtns = document.querySelector('.button-editor-trash-confirm');
        const deleteBtn = document.querySelector('.button-editor-trash-btn');

        if (deleteConfirm) {
            confirmBtns?.classList.add('confirm');
            deleteBtn?.classList.add('confirm');
        } else {
            confirmBtns?.classList.remove('confirm');
            deleteBtn?.classList.remove('confirm');
        };
    },[deleteConfirm])

    const resetForm = () => {
        setButton(buttonToEdit.data ? buttonToEdit.data : "");
        setLabel(buttonToEdit.label ? buttonToEdit.label : "");
        setIcon(buttonToEdit.icon);
    };

    const saveButtonEdits = async () => {
        let tempButtonArr = buttons;

        const btnUpdate = {
            active: buttonActive,
            added: buttonToEdit.data !== button ? Date.now() : buttonToEdit.added,
            data: buttonToEdit.ref === 'phone' ? formatPhoneNumberIntl(button) : buttonRefArr.includes(buttonToEdit.ref) ? getButtonLink(buttonToEdit.ref, button.replace(/\/$/,'')) : button.replace(/\/$/,''),
            icon: icon,
            label: label.length > 0 ? label : '',
            ref: buttonToEdit.ref
        };

        tempButtonArr[index] = btnUpdate;

        const update = { buttons: tempButtonArr };

        accountType === 'pro' ? setButtons(tempButtonArr) : buttonsActiveState(tempButtonArr, buttons, setButtons);
        
        setShowSpinner(true);
        
        await updateVcardObject(update, uid).then(async () => {
            await getUpdatedUserVcard().then(() => {
                setShowSpinner(false);
                setButtonHasChanges(false);
                setShowForm('');
            });
        });
    };

    switch (buttonToEdit.ref){
        case "phone":
            return (
                <div className='button-editor-container'>
                    {header}
                    <div className='button-editor-container-inner'>
                        <ButtonPreview button={buttonToEdit} data={button} icon={icon} label={label} profile_theme={profile_theme} />
                        <InputGroup>
                            <FloatingLabelInput
                                state={label}
                                setState={setLabel}
                                type='text'
                                id="edit-button-label"
                                label="Label (Optional)"
                                maxLength="25"
                                placeholder="Create a custom label for your button!"
                                onKeyUp={(e) => {e.preventDefault(); buttonToEdit.label === label ? setButtonHasChanges(false) : setButtonHasChanges(true);}}
                                style={{borderRadius: '2.5rem'}}
                            />
                        </InputGroup>
                        <InputGroup>
                            <label className='mb-0 phone-label button-type-float' htmlFor='edit-button-phone'>Phone</label>
                            <PhoneInput
                                id='edit-button-phone'
                                international
                                className='edit-phone-input'
                                countryCallingCodeEditable={false}
                                defaultCountry='US'
                                value={button.replaceAll(' ','')}
                                onChange={setButton}
                                onKeyUp={() => {(buttonToEdit.data === button || button === "") ? setButtonHasChanges(false) : setButtonHasChanges(true)}}
                            />
                        </InputGroup>
                        <InputGroup style={{justifyContent: 'space-between'}}>
                            {/* <IconPicker icon={icon} setIcon={setIcon} setButtonHasChanges={setButtonHasChanges} /> */}
                            <label className='button-editor-active-label'>
                                Disable Button
                                <input
                                    type='checkbox'
                                    id='website-checkbox'
                                    defaultChecked={buttonToEdit.active}
                                    onChange={e => {setButtonActive(e.target.checked); buttonToEdit.active === e.target.checked ? setButtonHasChanges(false) : setButtonHasChanges(true)}}
                                    disabled={accountType === 'basic' && index > 4}
                                />
                                {buttonActive === true ?
                                    <i className='far fa-square' />
                                    :
                                    <i className='far fa-square-check' />
                                }
                            </label>
                        </InputGroup>
                        <InputGroup className='button-editor-bottom-btns'>
                            <button
                                onClick={saveButtonEdits} 
                                className='button-editor-save-btn' 
                                disabled={!buttonHasChanges || showSpinner}>
                                {showSpinner ? <i className="fa-thin fa-spinner fa-spin-pulse"></i> : 'Save'}
                            </button>
                            <div className='button-editor-trash-wrap'>
                                <InputGroup className='button-editor-trash-confirm'>
                                    <button className='button-editor-delete-btn cancel' onClick={() => setDeleteConfirm(false)}>Cancel</button>
                                    <button className='button-editor-delete-btn delete' onClick={() => handleTrash()}>Confirm</button>
                                </InputGroup>
                                <button className='button-editor-trash-btn' onClick={() => setDeleteConfirm(true)} >
                                    Delete
                                </button>
                            </div>
                        </InputGroup>
                    </div>
                </div>
            );
        default:
            return (
                <div className='button-editor-container'>
                    {header}
                    <div className='button-editor-container-inner'>
                        <ButtonPreview button={buttonToEdit} data={button} icon={icon} label={label} profile_theme={profile_theme} />
                        <InputGroup>
                            <FloatingLabelInput
                                state={label}
                                setState={setLabel}
                                type='text'
                                id="edit-button-label"
                                label="Label (Optional)"
                                maxLength="25"
                                placeholder="Create a custom label for your button!"
                                onKeyUp={(e) => {e.preventDefault(); buttonToEdit.label === label ? setButtonHasChanges(false) : setButtonHasChanges(true);}}
                                style={{borderRadius: '2.5rem'}}
                            />
                        </InputGroup>
                        <InputGroup>
                            <FloatingLabelInput
                                state={button}
                                setState={setButton}
                                id='edit-button-default'
                                type={buttonToEdit.ref === 'email' ? 'email' : buttonRefArr.includes(buttonToEdit.ref) ? 'text' : 'url'}
                                label={`${buttonToEdit.ref.substring(0, 1).toUpperCase()}${buttonToEdit.ref.substring(1)}`}
                                onKeyUp={() => {(buttonToEdit.data === button || button === "") ? setButtonHasChanges(false) : setButtonHasChanges(true)}}
                                pattern={buttonToEdit.ref !== 'email' && !buttonRefArr.includes(buttonToEdit.ref) ? "(^((https|http)://)?[a-z0-9]+.[a-z]+(/[a-zA-Z0-9#]+/?)*$)|^((https|http)://)?(www.)?[a-z0-9]+.[a-z]+(/[a-zA-Z0-9#]+/?)*$" : null}
                                style={{borderRadius: '2.5rem'}}
                            />
                        </InputGroup>
                        <InputGroup style={{justifyContent: 'space-between'}}>
                            {/* <IconPicker icon={icon} setIcon={setIcon} setButtonHasChanges={setButtonHasChanges} /> */}
                            <label className='button-editor-active-label'>
                                Disable Button
                                <input
                                    type='checkbox'
                                    id='website-checkbox'
                                    defaultChecked={buttonToEdit.active}
                                    onChange={e => {setButtonActive(e.target.checked); buttonToEdit.active === e.target.checked ? setButtonHasChanges(false) : setButtonHasChanges(true)}}
                                    disabled={accountType === 'basic' && index > 4}
                                />
                                {buttonActive === true ?
                                    <i className='far fa-square' />
                                    :
                                    <i className='far fa-square-check' />
                                }
                            </label>
                        </InputGroup>
                        <InputGroup className='button-editor-bottom-btns'>
                            <button
                                onClick={saveButtonEdits} 
                                className='button-editor-save-btn' 
                                disabled={!buttonHasChanges || showSpinner}>
                                {showSpinner ? <i className="fa-thin fa-spinner fa-spin-pulse"></i> : 'Save'}
                            </button>
                            <div className='button-editor-trash-wrap'>
                                <InputGroup className='button-editor-trash-confirm'>
                                    <button className='button-editor-delete-btn cancel' onClick={() => setDeleteConfirm(false)}>Cancel</button>
                                    <button className='button-editor-delete-btn delete' onClick={() => handleTrash()}>Confirm</button>
                                </InputGroup>
                                <button className='button-editor-trash-btn' onClick={() => setDeleteConfirm(true)} >
                                    Delete
                                </button>
                            </div>
                        </InputGroup>
                    </div>
                </div>
            );
    }
};

export default ButtonEditor;